/** Заголовок мобильной модалки саджеста региона. */
export const REGION_SUGGEST_MOBILE_MODAL_TITLE = 'Выберите город или регион';

/** Отступ модалки от верха вьюпорта (px). */
export const REGION_SUGGEST_MOBILE_MODAL_TOP_OFFSET_PX = 40;
